import React from 'react';
import { Shield, LogOut, LayoutDashboard, TrendingUp, UserCog, Activity, Megaphone, Mail, Sparkles, Eye, HeartPulse } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useRoute } from '../../lib/router';

const NAV = [
  { label: 'Dashboard',     path: '/superadmin',               icon: LayoutDashboard },
  { label: 'Revenue',       path: '/superadmin/revenue',       icon: TrendingUp      },
  { label: 'Admins',        path: '/superadmin/admins',        icon: UserCog         },
  { label: 'Activity',      path: '/superadmin/activity',      icon: Activity        },
  { label: 'Announcements', path: '/superadmin/announcements', icon: Megaphone       },
  { label: 'Notifications', path: '/superadmin/notifications', icon: Mail            },
  // Inbound demo requests from the marketing site — lead pipeline.
  { label: 'Demo requests', path: '/superadmin/demo-requests', icon: Sparkles        },
  // Marketing analytics for the in-page "Watch demo" modal.
  { label: 'Demo views',    path: '/superadmin/demo-views',    icon: Eye             },
  // Deployment health — confirm migrations are applied + features wired.
  { label: 'Health',        path: '/superadmin/health',        icon: HeartPulse      },
];

export default function SuperAdminLayout({ children }) {
  const { logout, userProfile } = useAuth();
  const [{ pathname }, navigate] = useRoute();

  return (
    <div className="min-h-screen flex flex-col bg-slate-950 text-white">
      {/* Top bar */}
      <header className="sticky top-0 z-40 bg-slate-900 border-b border-slate-800 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 rounded-lg bg-red-600 flex items-center justify-center flex-shrink-0">
              <Shield size={14} className="text-white" />
            </div>
            <div className="leading-tight">
              <p className="text-sm font-semibold text-white">Super Admin</p>
              <p className="text-[11px] text-slate-400">System Control Panel</p>
            </div>
          </div>

          <nav className="flex items-center gap-1">
            {NAV.map(({ label, path, icon: Icon }) => {
              const active = path === '/superadmin' ? pathname === '/superadmin' : pathname.startsWith(path);
              return (
                <button
                  key={path}
                  onClick={() => navigate(path)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition
                    ${active
                      ? 'bg-red-600/20 text-red-400'
                      : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                    }`}
                >
                  <Icon size={14} />
                  {label}
                </button>
              );
            })}
          </nav>

          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-400">
              {userProfile?.first_name} {userProfile?.last_name}
            </span>
            <button
              onClick={logout}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm text-slate-400 hover:text-red-400 hover:bg-red-900/20 transition"
            >
              <LogOut size={14} /> Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-7xl mx-auto w-full px-4 py-8">
        {children}
      </main>
    </div>
  );
}
